// EROS — Renders a small "model wears X, height N cm" caption over the first PDP image.
// Reads from product metafield: custom.model_fit (single_line_text_field).
// Uses MutationObserver to inject once Horizon's gallery renders.

(function () {
  if (window.__erosModelFitInit) return;
  window.__erosModelFitInit = true;

  function injectCaption() {
    var holder = document.querySelector('[data-eros-model-fit]');
    if (!holder) return;
    var text = holder.dataset.modelFitText;
    var position = holder.dataset.modelFitPosition || 'bottom';
    if (!text) return;
    var galleries = document.querySelectorAll('media-gallery, .product-media-container, [data-product-media-gallery]');
    galleries.forEach(function (g) {
      if (g.dataset.erosFitDone) return;
      var firstSlide = g.querySelector('.media-item--first, [data-media-position="0"], .product-media-item:first-child, .product__media-item:first-child');
      if (!firstSlide) firstSlide = g.querySelector('.product-media, .product-media-item') || g.firstElementChild;
      if (!firstSlide) return;
      // Wrap if needed
      if (getComputedStyle(firstSlide).position === 'static') firstSlide.style.position = 'relative';
      var cap = document.createElement('div');
      cap.className = 'eros-model-fit eros-model-fit--' + position;
      cap.textContent = text;
      firstSlide.appendChild(cap);
      g.dataset.erosFitDone = '1';
    });
  }

  function init() { injectCaption(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  // Watch for Horizon's gallery loading async
  var mo = new MutationObserver(function () { injectCaption(); });
  mo.observe(document.body, { childList: true, subtree: true });
  document.addEventListener('shopify:section:load', init);
})();
